<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="d-flex align-content-stretch">
        <div class="d-print-none flex-fill align-self-center">
          <span class="toolbar-title">{{ label_procedure_training }}</span>
        </div>
        <div class="d-flex flex-column checkbox-column">
          <mat-checkbox
            class="small-checkbox"
            *ngIf="enableUserManageTrainings"
            [checked]="showTrainingsUserManages"
            color="warn"
            labelPosition="after"
            (change)="changeRolesUserManages($event.checked)"
            >Show Users I Manage</mat-checkbox
          >
          <mat-checkbox
            class="small-checkbox"
            [checked]="showArchived"
            color="warn"
            labelPosition="after"
            (change)="changeArchived($event.checked)"
            >Show All Training History</mat-checkbox
          >
          <mat-checkbox
            class="small-checkbox"
            [checked]="showAppendices"
            color="warn"
            labelPosition="after"
            (change)="changeAppendices($event.checked)"
            >Show Appendices</mat-checkbox
          >
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      class="d-print-none"
      mode="side"
      opened="true"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>
        <mat-list-item>
          <mat-icon
            matListItemIcon
            color="primary"
            class="blue"
            *ngIf="!isExpanded && !isShowing"
            >person_search</mat-icon
          >
          <mat-form-field
            class="filter-box no-subscript mb-1"
            *ngIf="isExpanded || isShowing"
          >
            <input
              matInput
              type="text"
              placeholder="Select User"
              [matAutocomplete]="auto"
              [(ngModel)]="userName"
              (keyup)="filterUsers($event)"
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option
                *ngFor="let user of usersFiltered"
                [value]="user.name"
                (onSelectionChange)="
                  getUserSelected($event.source.selected, user)
                "
              >
                {{ user.name }}
              </mat-option>
            </mat-autocomplete>
            <mat-icon
              *ngIf="userSelected"
              class="small-icon-button"
              aria-label="Clear"
              (click)="userSelected = null; userName = ''; format()"
              color="warn"
              >close</mat-icon
            >
          </mat-form-field>
        </mat-list-item>
        <mat-list-item style="height: unset">
          <div *ngIf="isExpanded" class="full-width">
            <div class="left-table-container table-container mat-container">
              <table mat-table [dataSource]="trainings">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Users</th>
                  <td mat-cell *matCellDef="let e">
                    {{ e.user.name }}
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="usersColumns; sticky: true"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: usersColumns"
                  (click)="navigate(row.user.id)"
                ></tr>
              </table>
            </div>
          </div>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content container-fluid pt-3" #tables id="tables">
          <div *ngIf="!trainings.length">
            <h6>No Required Procedure Training Found</h6>
          </div>
          <mat-accordion multi>
            <mat-expansion-panel
              *ngFor="let training of trainings; trackBy: trackByIdentity"
              [expanded]="trainings.length == 1 || navId == training.user?.id"
            >
              <mat-expansion-panel-header
                [collapsedHeight]="customCollapsedHeight"
                [expandedHeight]="customExpandedHeight"
              >
                <mat-panel-title
                  class="h6 pt-2 d-flex justify-content-between align-items-center"
                  id="{{ '_' + training.user?.id }}"
                >
                  <div class="d-flex align-items-center">
                    {{ training.user?.name }}

                    <div
                      *ngIf="training.showExtraTitle"
                      class="extra-training-title ml-3 d-flex align-items-center"
                    >
                      <h6 class="mb-0">Extra Training</h6>
                      <mat-icon-button
                        class="ml-2"
                        *ngIf="
                          extraTrainingsPermission ||
                          currentUser?.id == training?.user?.id
                        "
                        type="button"
                        (click)="addProcedurePopup(training)"
                      >
                        <mat-icon color="accent">add_box</mat-icon>
                      </mat-icon-button>
                    </div>
                  </div>
                  <div
                    #actions
                    *ngIf="hasActions(training)"
                    class="d-flex align-items-center"
                  >
                    <button
                      *ngIf="training.selected"
                      mat-mini-fab
                      matTooltip="Execute Actions for Selected Items"
                      color="primary"
                      class="actions-button d-print-none material-symbols-outlined"
                      (click)="
                        $event.stopPropagation(); executeActions(training)
                      "
                    >
                      <mat-icon class="white"
                        >playlist_add_check_circle</mat-icon
                      >
                    </button>
                    <span
                      *ngIf="!training.selectMultiple"
                      class="d-flex align-items-center blue small"
                      >Select Multiple Procedure Trainings
                      <mat-icon class="blue">arrow_right_alt</mat-icon></span
                    >
                    <button
                      *ngIf="!training.selectMultiple"
                      mat-icon-button
                      matTooltip="Enable multiple selections"
                      class="ml-2 actions-button d-print-none"
                      aria-label="Select Multiple"
                      (click)="
                        $event.stopPropagation(); selectMultiple(training, true)
                      "
                    >
                      <mat-icon color="accent">checklist</mat-icon>
                    </button>
                    <button
                      *ngIf="training.selectMultiple"
                      mat-icon-button
                      matTooltip="Disable multiple selections"
                      class="ml-2 actions-button d-print-none"
                      aria-label="Deselect Multiple"
                      (click)="
                        $event.stopPropagation();
                        selectMultiple(training, false)
                      "
                    >
                      <mat-icon color="warn">remove_done</mat-icon>
                    </button>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div
                #trainingContainer
                class="mat-container"
                [id]="'traningContainer-' + training.user?.id"
              >
                <div
                  class="extra-title-sentinel"
                  [id]="'extraTitleSentinel-' + training.user?.id"
                ></div>
                <div class="mb-4">
                  <procedure-trainings-table-component
                    *ngIf="training?.trainingsWithRole"
                    [trainings]="training.trainingsWithRole"
                    [completeTrainingInfo]="training"
                    [user]="currentUser"
                    [supervised]="supervised"
                    [filter]="filter"
                    [label_procedure_number]="label_procedure_number"
                    [label_procedure_title]="label_procedure_title"
                    [message_general_error]="message_general_error"
                    [admin]="admin"
                    [label_training_complete_option]="
                      label_training_complete_option
                    "
                    [label_training_remove_option]="
                      label_training_remove_option
                    "
                    [selectMultiple]="training.selectMultiple"
                    (selected)="training.selected = $event"
                  >
                  </procedure-trainings-table-component>
                </div>
                <div
                  #extraTrainingHeader
                  class="extra-training-header ml-2 d-flex align-items-center mb-2"
                  [id]="'extraTrainingHeader-' + training.user?.id"
                >
                  <h6>Extra Training</h6>
                  <mat-icon-button
                    class="ml-2"
                    *ngIf="
                      extraTrainingsPermission ||
                      currentUser?.id == training?.user?.id
                    "
                    type="button"
                    (click)="addProcedurePopup(training)"
                  >
                    <mat-icon color="accent">add_box</mat-icon>
                  </mat-icon-button>
                </div>

                <procedure-trainings-table-component
                  [trainings]="training?.trainingsWithoutRole"
                  [completeTrainingInfo]="training"
                  [currentUser]="currentUser"
                  [supervised]="supervised"
                  [filter]="filter"
                  [user]="currentUser"
                  [label_procedure_number]="label_procedure_number"
                  [label_procedure_title]="label_procedure_title"
                  [message_general_error]="message_general_error"
                  [admin]="admin"
                  (deleteProcedureTraining)="deleteTraining($event)"
                  [extraTrainingsPermission]="extraTrainingsPermission"
                  [label_training_complete_option]="
                    label_training_complete_option
                  "
                  [showAppendices]="showAppendices"
                  [selectMultiple]="training.selectMultiple"
                  (selected)="training.selected = $event"
                ></procedure-trainings-table-component>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
